import React from "react";
import PropTypes from "prop-types";
import { Breadcrumbs, BreadcrumbsItem, Container, Display3 } from "@sainsburys-tech/fable";
import { Link } from "react-router-dom";
import { NewWindow } from '@sainsburys-tech/icons'
import UnderlinedButton from "../UnderlinedButton";
import { Event } from "../Tracking";
import { headerTextStyle, headerLastTextStyle, display3Style } from "./StoreDetailsPageHeader.styles";

// Custom link component that adapts React Router's Link to Fable's linkAs prop
const CustomLink = React.forwardRef(({ href, ...props }, ref) => (
  <Link ref={ref} to={href} {...props} />
));
CustomLink.displayName = "CustomLink";

// Slugify functionality replicated from storelocator-web repository
// https://github.com/JSainsburyPLC/storelocator-web/blob/develop/app/utils/strings.js
const slugify = str => {
  if (!str) {
    return str;
  }

  return str
    .toString()
    .toLowerCase()
    .trim()
    .replace(/&/g, "-and-") // Replace & with 'and'
    .replace(/[\s\W-]+/g, "-") // Replace spaces, non-word characters and dashes with a single dash (-)
    .replace(/-$/, ""); // Remove last floating dash if exists;
};

const storeDetailsUrl = store => {
  const storeSlug = slugify(store.otherName || store.name);

  return `https://stores.sainsburys.co.uk/${store.storeId}/${storeSlug}`;
};

const StoreDetailsPageHeader = props => (
  <React.Fragment>
    <Container>
      <Breadcrumbs colourScheme="dark" linkAs={CustomLink}>
        <BreadcrumbsItem style = {headerTextStyle} href="/stores/">
          Stores
        </BreadcrumbsItem>
        <BreadcrumbsItem style={headerLastTextStyle} href={`/stores/${props.store.storeId}`} aria-current="page">
          {props.store.name}
        </BreadcrumbsItem>
      </Breadcrumbs>

      <Display3 style={display3Style}>
        {props.store.name} ({props.store.storeId})
      </Display3>
      <span>
        <a href={storeDetailsUrl(props.store)} target="_blank">
          <UnderlinedButton
            color="dark"
            onClick={() =>
              Event(
                "Link Events",
                "Contact Details",
                storeDetailsUrl(props.store)
              )
            }
          >
            Contact details <NewWindow title="External link" style={{ width: '20px', height: '20px'}}/>
          </UnderlinedButton>
        </a>
      </span>
    </Container>
  </React.Fragment>
);

StoreDetailsPageHeader.propTypes = {
  store: PropTypes.object,
  showLightingPanel: PropTypes.bool.isRequired,
  loadFailed: PropTypes.bool
};

export default StoreDetailsPageHeader;
